module.exports = __webpack_public_path__ + "media/flags/005-portugal-f293964f.svg";